import { countries } from 'countries-list'
import { type CountryCode, getCountries, getCountryCallingCode } from 'libphonenumber-js'

export const PRIORITY_COUNTRIES = ['US', 'CA', 'GB', 'FR', 'IN']

export const buildContactoCountryData = () => {
  const validCountries = getCountries()

  return [
    ...PRIORITY_COUNTRIES.map((iso) => [
      countries[iso as keyof typeof countries].name,
      iso as CountryCode,
      getCountryCallingCode(iso as CountryCode),
      countries[iso as keyof typeof countries].continent,
    ]),
    ...Object.entries(countries)
      .filter(
        ([iso]) => !PRIORITY_COUNTRIES.includes(iso) && validCountries.includes(iso as CountryCode),
      )
      .sort(([, a], [, b]) => a.name.localeCompare(b.name))
      .map(([iso, data]) => [
        data.name,
        iso as CountryCode,
        getCountryCallingCode(iso as CountryCode),
        data.continent,
      ]),
  ] as Array<[string, CountryCode, string, string]>
}
